<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <span  style="margin:15px 0 -1px 0;
               float:right;
               bottom: 50px;
               position: relative;" *ngIf="isEdit">
    <i class="fal fa-edit"  tooltip="{{'GENERIC_EDIT' | translate:locale.language}}" *ngIf="dataConfig.form.get(['contract']).disabled" (click)="edition()"></i>
    <div *ngIf="!dataConfig.form.get(['contract']).disabled">
      <i class="fal fa-undo" tooltip="{{'GENERIC_UNDO' | translate:locale.language}}" (click)="undoBlock()" ></i>
      <span [ngClass]="dataConfig.form.get(['contract']).invalid || dataConfig.form.get(['contract']).pristine ? 'not-allowed' : '' " (click)="saveBlock()">
          <i tooltip="{{'GENERIC_SAVE' | translate:locale.language}}" class="fal fa-save"></i>
        </span>

    </div>
  </span>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-file-signature'"
          [title]="'GENERIC_NAME'"
          [config]="dataConfig.groupConfigs.groupConfigs[1].config"
          [form]="dataConfig.form.get(['contract' ,'displayName'])"
          [isEdit]="false"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', ''])"
          (undo)="undo(['displayName'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-file-invoice-dollar'"
          [title]="'CONTRACT_FORM_INVOICING_DATE'"
          [config]="dataConfig.groupConfigs.groupConfigs[2].config"
          [form]="dataConfig.form.get(['contract' ,'invoicing'])"
          [isAdd]="isEdit"
          [isEdit]="isEdit"
          [status]="0"
          [paramEdit]="{text: 'none', icon: '', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', ''])"
          (undo)="undo(['invoicing'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fal fa-hdd'"
          [title]="'GENERIC_PRODUCT'"
          [config]="dataConfig.groupConfigs.groupConfigs[3].config"
          [form]="dataConfig.form.get(['contract' ,'productID'])"
          [isEdit]="false"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'productID'])"
          (undo)="undo(['productID'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group class="extra-lon-label"
          [icon]="'fal fa-sliders-v-square'"
          [title]="'CONTRACT_FORM_SETTING_TITLE'"
          [config]="dataConfig.groupConfigs.groupConfigs[18].config"
          [form]="dataConfig.form.get(['contract' ,'setting'])"
          [isEdit]="false"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', ''])"
          (undo)="undo(['isIndex'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
<!--      <div class="width-18-margin-14">-->
<!--        <storever-element-group-->
<!--          [icon]="'fa-analytics'"-->
<!--          [title]="'CONTRACT_FORM_INDEXATION_OF_CONTRACT'"-->
<!--          [config]="dataConfig.groupConfigs.groupConfigs[4].config"-->
<!--          [form]="dataConfig.form.get(['contract' ,'isIndex'])"-->
<!--          [isEdit]="false"-->
<!--          [status]="'0'"-->
<!--          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"-->
<!--          (save)="save(['ContractEditComponent', ''])"-->
<!--          (undo)="undo(['isIndex'])"-->
<!--          [stylingClass]="'dynamic-form'">-->
<!--        </storever-element-group>-->
<!--      </div>-->
<!--      <div class="width-18-margin-14">-->
<!--        <storever-element-group-->
<!--          [icon]="'fa-file-invoice'"-->
<!--          [title]="'CONTRACT_FORM_CUSTOM_INVOICE_TITLE'"-->
<!--          [config]="dataConfig.groupConfigs.groupConfigs[5].config"-->
<!--          [form]="dataConfig.form.get(['contract' ,'customInvoice'])"-->
<!--          [isEdit]="false"-->
<!--          [status]="'0'"-->
<!--          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"-->
<!--          (save)="save(['ContractEditComponent', 'customInvoice'])"-->
<!--          (undo)="undo(['customInvoice'])"-->
<!--          [stylingClass]="'dynamic-form'">-->
<!--        </storever-element-group>-->
<!--      </div>-->
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-stopwatch'"
          [title]="'CONTRACT_FORM_TRIGGER_START_TITLE'"
          [config]="dataConfig.groupConfigs.groupConfigs[6].config"
          [form]="dataConfig.form.get(['contract' ,'triggerStart' ])"
          [isEdit]="false"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'triggerStart'])"
          (undo)="undo(['triggerStart'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-hourglass-start'"
          [title]="'CONTRACT_FORM_RETRACTATION_DELAY'"
          [config]="dataConfig.groupConfigs.groupConfigs[7].config"
          [form]="dataConfig.form.get(['contract' ,'delay'])"
          [isEdit]="false"
          [infoBull]="'CONTRACT_FORM_RULES_INFO_BULL_PRE_NOTICE'"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'retractationDelay'])"
          (undo)="undo(['retractationDelay'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-contract-recurrence-option
          [icon]="'fa-history'"
          [title]="'CONTRACT_FORM_RECURRENCE'"
          [config]="dataConfig.groupConfigs.groupConfigs[8].config"
          [form]="dataConfig.form.get(['contract' ,'recurrence'])"
          [formParent]="dataConfig.form.get(['contract'])"
          [data]="contract"
          [isEdit]="dataConfig.form.get(['contract']).disabled ? 'true' : 'false'">
        </storever-contract-recurrence-option>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-page-break'"
          [title]="'CONTRACT_FORM_SPLIT'"
          [config]="dataConfig.groupConfigs.groupConfigs[9].config"
          [form]="dataConfig.form.get(['contract' ,'split'])"
          [isEdit]="false"
          [status]="'0'"
          [infoBull]="'CONTRACT_FORM_RULES_INFO_BULL_SPLIT'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'split'])"
          (undo)="undo(['split'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-concierge-bell'"
          [title]="'CONTRACT_FORM_SLA_TITLE'"
          [config]="dataConfig.groupConfigs.groupConfigs[10].config"
          [form]="dataConfig.form.get(['contract' ,'sla'])"
          [isEdit]="false"
          [status]="'0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'sla'])"
          (undo)="undo(['sla'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-18-margin-14">
        <storever-element-group
          [icon]="'fa-usd-circle'"
          [title]="'CONTRACT_FORM_CURRENCY'"
          [config]="dataConfig.groupConfigs.groupConfigs[11].config"
          [form]="dataConfig.form.get(['contract' ,'currency'])"
          [isEdit]="false"
          [status]="'0'"
          [infoBull]="getCurrencyInfo()"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContractEditComponent', 'currency'])"
          (undo)="undo(['currency'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>

    </ul>
  </form>
  <span *ngIf="error && isEdit">
      <span [ngStyle]="{'color': error[0]?.color}" *ngIf="error[0]" style="padding-right: 10px ; padding-left: 10px">
           <strong>  {{error[0]?.message | translate:locale.language }} </strong>
           <span *ngIf=error[0]?.extraData>{{ error[0]?.extraData }}</span>
      </span>
   </span>
  <storever-rules-edit class="marginBottom"
    [dataConfig]="dataConfig"
    [form]="dataConfig.form"
    [edit]="isEdit"
  ></storever-rules-edit>
</ng-template>

<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
<!--  <pre style="flex: 1 1 0px">dataConfig: {{dataConfig?.groupConfigs?.groupConfigs[2]|json}}</pre>-->
<!--  <pre style="flex: 1 1 0px">dataConfig form split: {{dataConfig.form.get(['split', 'split', 'id']).value}}</pre>-->
  <pre style="flex: 1 1 0px">dataConfig form: {{getInvalidControls(dataConfig.form.controls['contract'])}}</pre>
<!--  <pre style="flex: 1 1 0px">content: {{content|async|json}}</pre>-->
</div>


